import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-bill-modal',
  templateUrl: './view-bill-modal.component.html',
  styleUrls: ['./view-bill-modal.component.css']
})
export class ViewBillModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
